import { Button, ButtonDiv, ButtonGroup, ButtonIcon } from './Button';
import { Input } from './Input/Input';
import { Link } from './Link';

export const V2 = {
  Button,
  ButtonDiv,
  ButtonIcon,
  Link,
  ButtonGroup,
  Input,
};
